import styled, { css } from 'styled-components';
import { Flex } from '../../../../layout/Flex';
import { BusinessStatisticItemProps } from './types';

export const Wrapper = styled(Flex)
    .withConfig({ displayName: 'BusinessStatisticItem' })
    .attrs<BusinessStatisticItemProps>((props) => ({
        ...props,
        position: 'relative',
        width: '100%',
        direction: 'row',
        justifyContent: 'space-between',
        pt: props.pt || 2,
    }))`
        ${(props) =>
            props.withNestedListMarker &&
            css`
                &::before {
                    position: absolute;
                    top: -8px;
                    left: 0;
                    display: block;
                    width: 8px;
                    height: 100%;
                    content: '';
                    border-left: 1px solid var(--divider);
                    border-bottom: 1px solid var(--divider);
                }

                &:last-child {
                    &::before {
                        border-bottom-left-radius: 4px;
                    }
                }
            `}
    `;
